import type { Banner } from "@/types/comic";

export const banners: Banner[] = [
  {
    id: "banner-1",
    comicId: "heart-signal",
    title: "心动信号",
    subTitle: "심장 신호",
    tag: "本周最热",
    description:
      "雨天共伞的偶遇，让两颗心开始靠近。当心动变成信号，谁能先说出口？高甜恋爱连载中。",
    image:
      "https://readdy.ai/api/search-image?query=Atmospheric%20romantic%20city%20street%20at%20dusk%20with%20warm%20bokeh%20lights%20and%20soft%20pink%20and%20orange%20gradient%20sky%2C%20dreamy%20cinematic%20illustration%2C%20no%20text%2C%20clean%20composition%20with%20empty%20space%20on%20the%20left%2C%20subtle%20falling%20petals%2C%20modern%20artistic%20webtoon%20background%20aesthetic&width=1600&height=900&seq=banner-01&orientation=landscape",
  },
  {
    id: "banner-2",
    comicId: "starry-magic-academy",
    title: "星夜魔法学院",
    subTitle: "별밤 마법학원",
    tag: "奇幻推荐",
    description:
      "平凡少女误入天才学院，禁忌魔力觉醒。魔法的代价究竟是记忆，还是生命？奇幻冒险开启。",
    image:
      "https://readdy.ai/api/search-image?query=Majestic%20magic%20academy%20castle%20under%20a%20vibrant%20starry%20night%20sky%20with%20glowing%20purple%20and%20teal%20aurora%2C%20fantasy%20concept%20illustration%2C%20no%20text%2C%20clean%20composition%20with%20empty%20space%20on%20the%20left%2C%20mystical%20floating%20runes%20and%20soft%20glow%2C%20modern%20artistic%20webtoon%20background%20aesthetic&width=1600&height=900&seq=banner-02&orientation=landscape",
  },
  {
    id: "banner-3",
    comicId: "seventh-witness",
    title: "第七位证人",
    subTitle: "일곱 번째 증인",
    tag: "悬疑烧脑",
    description:
      "六名证人相继离奇身亡，第七位从未现身。隐藏在黑暗里的真相，一触即发。",
    image:
      "https://readdy.ai/api/search-image?query=Moody%20rainy%20neon%20lit%20back%20alley%20at%20night%20with%20deep%20blue%20and%20crimson%20shadows%20and%20wet%20reflections%2C%20suspense%20cinematic%20illustration%2C%20no%20text%2C%20clean%20composition%20with%20empty%20space%20on%20the%20left%2C%20foggy%20atmosphere%2C%20modern%20artistic%20webtoon%20background%20aesthetic&width=1600&height=900&seq=banner-03&orientation=landscape",
  },
  {
    id: "banner-4",
    comicId: "cat-cafe-diary",
    title: "猫咪咖啡馆日记",
    subTitle: "고양이 카페 일기",
    tag: "暖心治愈",
    description:
      "失业的社恐青年接手猫咪咖啡馆，在十三只猫的陪伴下，重新找回生活的温柔。",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20sunlit%20cafe%20interior%20with%20wooden%20furniture%20and%20fluffy%20cats%20napping%20by%20a%20large%20window%20with%20warm%20green%20and%20cream%20tones%2C%20healing%20lifestyle%20illustration%2C%20no%20text%2C%20clean%20composition%20with%20empty%20space%20on%20the%20left%2C%20soft%20afternoon%20light%20and%20plants%2C%20modern%20artistic%20webtoon%20background%20aesthetic&width=1600&height=900&seq=banner-04&orientation=landscape",
  },
];